<template>
    <div class="dropdown-list">
        <AppTextField
            class="search"
            @input="$emit('search', $event)"
            v-if="isSearchable"
            icon-right="search"
        />

        <div class="list-wrapper">
            <AppLoading
                class="empty"
                v-if="isLoading"
            />

            <ul v-else-if="items.length > 0">
                <li
                    v-for="(item,index) in items"
                    :key="index"
                    class="item"
                    @click="$emit('select', item)"
                >
                    <slot :item="item">
                        {{ item }}
                    </slot>
                </li>
            </ul>

            <p
                class="item empty"
                v-else
            >
                No result found.
            </p>
        </div>
    </div>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			default: () => []
		},

		isLoading: {
			type: Boolean,
			default: false
		},

		isSearchable: {
			type: Boolean,
			default: true
		}
	}
}
</script>

<style lang="scss" scoped>
.dropdown-list {
    box-shadow: 0 3px 6px $shadow;
    padding: 10px;
    background-color: #fff;
    border: 1px solid $light;
    z-index: 999;

    .search {
        width: 100%;
        z-index: 2;
    }

    .list-wrapper {
        max-height: 300px;
        overflow: auto;
        margin: 10px 0;

        .item {
            cursor: pointer;

            &:hover {
                background-color: $light2;
            }
        }
    }

    .item {
        padding: 5px 0;
    }

    .empty {
        text-align: center;
        height: 100%;
        width: 100%;
    }
}
</style>
